"use strict";

exports.__esModule = true;

var theme_1 = require("./theme");
/**
 * Return themed log-method style
 * @param style The style
 * @param type The method
 */


var Themed = function Themed(style, method, styles) {
  return styles["LOG_" + method.toUpperCase() + "_" + style.toUpperCase()] || styles["LOG_" + style.toUpperCase()];
};
/**
 * console-feed
 */


exports.Root = theme_1["default"]('div')({
  wordBreak: 'break-word'
});
/**
 * console-message
 */

exports.Message = theme_1["default"]('div')(function (_a) {
  var _b = _a.theme,
      styles = _b.styles,
      method = _b.method;
  return {
    position: 'relative',
    display: 'flex',
    color: Themed('color', method, styles),
    backgroundColor: Themed('background', method, styles),
    borderTop: "1px solid " + Themed('border', method, styles),
    borderBottom: "1px solid " + Themed('border', method, styles),
    marginTop: -1,
    marginBottom: +/^warn|error$/.test(method),
    paddingLeft: 10,
    boxSizing: 'border-box',
    '& *': {
      verticalAlign: 'top',
      boxSizing: 'border-box',
      fontFamily: styles.BASE_FONT_FAMILY,
      whiteSpace: 'pre-wrap',
      fontSize: styles.BASE_FONT_SIZE
    },
    '& a': {
      color: 'rgb(177, 177, 177)'
    }
  };
});
/**
 * message-icon
 */

exports.Icon = theme_1["default"]('div')(function (_a) {
  var _b = _a.theme,
      styles = _b.styles,
      method = _b.method;
  return {
    width: styles.LOG_ICON_WIDTH,
    height: styles.LOG_ICON_HEIGHT,
    backgroundImage: Themed('icon', method, styles),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%'
  };
});
/**
 * console-content
 */

exports.Content = theme_1["default"]('div')(function (_a) {
  var _b = _a.theme,
      styles = _b.styles,
      method = _b.method;
  return {
    clear: 'right',
    position: 'relative',
    padding: styles.PADDING,
    marginLeft: 15,
    minHeight: 18,
    flex: 'auto',
    width: 'calc(100% - 15px)'
  };
});